<template>
  <div class="mobile gun-sight" ref="gunSightRef">
    <img 
      v-for="(item, itemIndex) in state.items" 
      :key="`item-${itemIndex}-${item.key}`"
      class="gun-sight-item" 
      :class="{ 'disappearing': item.disappearing }"
      :style="{ left: item.left + 'px', top: item.top + 'px' }"
      src="~@/assets/imgs/act/mwr/dragon/gun-sight.png" 
      alt="gun-sight"
      @click="handleItemClick(itemIndex)"
    />
    <!-- 伤害数字显示 -->
    <transition-group name="damage" tag="div" class="damage-container">
      <div 
        v-for="damage in state.damageList" 
        :key="damage.id"
        class="damage-text"
        :style="{ left: damage.x + 'px', top: damage.y + 'px' }"
      >
        -{{ damage.value }}
      </div>
    </transition-group>
  </div>
</template>

<script setup>
/* eslint-disable */
import { reactive, ref, onMounted, nextTick } from 'vue'
import { inject } from 'vue'
import { toastService } from '@/utils/toastService'
import { useI18n } from 'vue-i18n'
const mwrData = inject('mwrData')
const { t } = useI18n()
const emit = defineEmits(['update:damage'])
const gunSightRef = ref(null)
const ITEM_SIZE = 56 // 每个item的尺寸
const ITEM_COUNT = 4 // item数量
const MIN_DISTANCE = 80 // 最小距离，避免重叠

const state = reactive({
  items: [],
  damageList: [],
  isLocked: false // 锁定状态，防止连续点击
})

// 检查两个位置是否重叠
function isOverlapping(x1, y1, x2, y2, minDistance) {
  const distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2))
  return distance < minDistance
}

// 检查新位置是否与已有位置重叠
function checkOverlap(newX, newY, existingItems, minDistance) {
  return existingItems.some(item => 
    isOverlapping(newX, newY, item.left, item.top, minDistance)
  )
}

// 生成随机位置
function generateRandomPositions() {
  if (!gunSightRef.value) return []
  
  const container = gunSightRef.value
  const containerWidth = container.offsetWidth
  const containerHeight = container.offsetHeight
  const maxX = containerWidth - ITEM_SIZE
  const maxY = containerHeight - ITEM_SIZE
  
  const positions = []
  const maxAttempts = 100 // 最大尝试次数，避免无限循环
  
  for (let i = 0; i < ITEM_COUNT; i++) {
    let attempts = 0
    let x, y
    
    do {
      x = Math.random() * maxX
      y = Math.random() * maxY
      attempts++
    } while (checkOverlap(x, y, positions, MIN_DISTANCE) && attempts < maxAttempts)
    
    // 确保位置是整数像素，避免 iOS 上的模糊
    positions.push({ 
      left: Math.round(x), 
      top: Math.round(y),
      disappearing: false,
      key: Date.now() + Math.random() // 用于强制重新渲染
    })
  }
  
  return positions
}

// 初始化位置
function initPositions() {
  state.items = generateRandomPositions()
}

// 处理item点击
function handleItemClick(index) {
  if (!mwrData.shootDetail.totalShotCount || mwrData.shootDetail.totalShotCount - mwrData.shootDetail.usedShotCount <= 0) {
    toastService.showSmall(t('mwr.dragon.noTurn'))
    return
  }
  // 如果已锁定或该item正在消失，忽略点击
  if (state.isLocked || state.items[index]?.disappearing) return
  
  // 锁定，防止连续点击
  state.isLocked = true
  
  // 标记该item为消失状态
  state.items[index].disappearing = true
  
  // 生成随机伤害值（600-800）
  const damage = Math.floor(Math.random() * 201) + 600
  
  // 获取被点击的item的位置
  const clickedItem = state.items[index]
  if (!clickedItem) return
  
  // 计算item的右上角位置（item的right和top）
  // item的右上角 = item.left + item宽度，item.top
  // 为了显示在右上角，稍微偏移一点
  // 确保是整数像素，避免 iOS 上的模糊
  const damageX = Math.round(clickedItem.left + ITEM_SIZE - 10)
  const damageY = Math.round(clickedItem.top - 10)
  
  // 添加伤害数字到列表
  const damageId = Date.now() + Math.random()
  state.damageList.push({
    id: damageId,
    value: damage,
    x: damageX,
    y: damageY
  })
  
  // 3秒后移除伤害数字
  setTimeout(() => {
    const damageIndex = state.damageList.findIndex(d => d.id === damageId)
    if (damageIndex > -1) {
      state.damageList.splice(damageIndex, 1)
    }
  }, 3000)
  
  // 等待消失动画完成（0.5秒）后重新生成所有位置，并解锁
  setTimeout(() => {
    initPositions()
    // 解锁，允许下次点击
    state.isLocked = false
    emit('update:damage', damage)
  }, 500) // 与CSS动画时长一致
}

onMounted(() => {
  nextTick(() => {
    initPositions()
  })
})
</script>

<style scoped lang="less" src="./mobile_style.less"></style>